import { useState } from 'react'
import { publishEvent, getActionOfType } from '../../utils'
import { ACTION_TYPE } from '../../constants'
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Button } from 'reactstrap'
import useForm from '../CustomHooks/FormHook'
import { useNavigate } from 'react-router'

export default function AppObjectActionsForm({ object, source }) {
  console.log('AppObjectActionsForm rendered', object)

  const [modal, setModal] = useState(false)
  let initialValues = null
  if (object.actions.length > 0) {
    initialValues = { action: object.actions[0].id }
  }
  const { inputs, handleInputChange } = useForm(initialValues)
  const deleteAction = getActionOfType(object.type.actions, ACTION_TYPE.delete)
  const toggle = () => setModal(!modal)
  const navigate = useNavigate()

  function deleteConfirmed() {
    console.log('AppObjectActionForm.deleteConfirmed')
    publishEvent(`DELETE OBJECT ${object.id}`, deleteAction, 'AppObjectActionsForm.deleteConfirmed')
    toggle()
  }

  function deleteCancelled() {
    console.log('AppObjectActionForm.deleteCancelled')
    toggle()
  }

  function goButtonClicked() {
    console.log(`AppObjectActionForm.goButtonClicked objectId: ${object.id}, actionId: ${inputs.action}`)
    if (deleteAction && (deleteAction.id === inputs.action)) {
      toggle()
    } else {
      const sourceString = source ? `&source=${encodeURIComponent(source)}` : ''
      navigate(`/object/${object.id}?actionId=${inputs.action}${sourceString}`)
    }
  }

  let formComponent = ''
  if (object.actions.length > 0) {
    const options = []
    object.actions.forEach((action) => {
      options.push(<option key={action.id} value={action.id}>{action.name}</option>)
    })
    formComponent =
      <>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Delete {object.type.name}</ModalHeader>
          <ModalBody style={{ fontSize: 'large' }}>
            Are you sure?
          </ModalBody>
          <ModalFooter>
            <Button data-cy='app-object-action-form-delete-button' color="danger" onClick={deleteConfirmed}>Delete</Button>{' '}
            <Button data-cy='app-object-action-form-cancel-button' color="secondary" onClick={deleteCancelled}>Cancel</Button>
          </ModalFooter>
        </Modal>
        <FormGroup className="mb-2 mr-sm-2 mb-sm-0" style={{ display: 'inline-block' }}>
          <Label for="actions" style={{ fontWeight: 'bold', height: '35px', paddingRight: '10px' }}>{object.type.name} Actions</Label>
          <Input 
            data-cy='action-dropdown'
            type="select"
            bsSize="sm"
            name="action"
            id="actions"
            onChange={handleInputChange}
            style={{ width: 'auto', display: 'inline-block', marginRight: '10px' }}>
            {options}
          </Input><Button 
            data-cy='action-form-go-button'
            style={{ height: '30px', position: 'relative', top: '-2px' }}
            name="goButton"
            color="primary"
            onClick={goButtonClicked}>Go</Button>
        </FormGroup>
      </>
  }
  return (formComponent)
}
